//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = section.querySelector(".productATCQuantityValue") ? parseInt(section.querySelector(".productATCQuantityValue").textContent) : 1;

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }
                // update the thumbnail active class
                section.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                section.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update active variant on input changes
    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })


    /**************
     Update Product
     ***************/
    async function updateProduct() {

        // variables to check if elements exist
        let productATCExists = section.querySelector(".productATC") || false;
        let sellingPlanExists = section.querySelector(".productSelling") || false;

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`)?.value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant && section.querySelector(".productATC")) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        section.querySelectorAll(".productPriceReal").forEach(p => p.textContent = price(activeVariant.price * quantity));
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelectorAll(".productPriceReal").forEach(p => p.classList.add("sale"));
            section.querySelectorAll(".productPriceCompare").forEach(p => p.textContent = price(activeVariant.compare_at_price * quantity));
            section.querySelectorAll(".productPriceSavings").forEach(p => p.textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`);
        } else {
            section.querySelectorAll(".productPriceReal").forEach(p => p.classList.remove("sale"));
            section.querySelectorAll(".productPriceCompare").forEach(p => p.textContent = "");
            section.querySelectorAll(".productPriceSavings").forEach(p => p.textContent = "");
        }

        /**************
         Selling Plan
         ***************/

        if (sellingPlanExists) {
            let activeVariantPlan = activeVariant.selling_plan_allocations[0];

            // find the correct selling_plan_allocation
            for (let plan of activeVariant.selling_plan_allocations) {
                if (plan.selling_plan_id === parseInt(section.querySelector('select').value)) {
                    activeVariantPlan = plan;
                }
            }

            // update savings text
            let save = (1 - (activeVariantPlan.price / activeVariant.price)) * 100;
            section.querySelector('.productSellingLabelBodyTopTitle').textContent = `Subscribe & Save ` + save.toFixed(0) + `%`;

            // save parent elements
            const once = section.querySelector(".productSellingLabelBody.once");
            const sub = section.querySelector(".productSellingLabelBody.sub");

            // update compare at price
            once.querySelector(".productSellingLabelBodyPriceCompare").textContent = "";
            sub.querySelector(".productSellingLabelBodyPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity, true);
            if (activeVariant.compare_at_price > activeVariant.price) {
                once.querySelector(".productSellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
            }

            // update actual price
            once.querySelector(".productSellingLabelBodyPriceReal").textContent = price(activeVariant.price * quantity, true);
            sub.querySelector(".productSellingLabelBodyPriceReal").textContent = price(activeVariantPlan.price * quantity, true);


            // update price outside of selling plan module if selling plan is selected
            if (section.querySelector(".productSellingLabelInput:checked")?.value === "sub") {
                section.querySelectorAll(".productPriceReal").forEach(p => p.textContent = price(activeVariantPlan.price * quantity));
                section.querySelectorAll(".productPriceCompare").forEach(p => p.textContent = price(activeVariantPlan.compare_at_price * quantity));
            }

            // Show pickup element if one time purchase is selected
            section.querySelector(".productPickupAvailabilityContainer").classList.toggle("active", section.querySelector(".productSellingLabelInput:checked")?.value === "once")
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (!activeVariant.available) {
            section.querySelector(".productATC")?.setAttribute("disabled", true);
            section.querySelector(".productATC")?.setAttribute("textContent", "Sold Out");
        } else {
            section.querySelector(".productATC")?.removeAttribute("disabled");
            section.querySelector(".productATC")?.setAttribute("textContent", "Add To Cart");
        }


        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productATCQuantityButton.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productATCQuantityValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productATCQuantityButton.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productATCQuantityValue").textContent = quantity;
        updateProduct();
    });


    /**************
     Tabs
     ***************/
    section.querySelector(".productTabs").addEventListener("click", function (e) {
        // If a tab button wasn't clicked exit
        if (!e.target.classList.contains("productTabsButtonItemsButton")) {
            return;
        }

        const button = e.target;
        const tab = button.getAttribute("data-tab");
        const matchingTab = section.querySelector(`.productTabsContent[data-tab="${tab}"]`);

        // remove active class from previously active tabs
        section.querySelector(".productTabsButtonItemsButton.active").classList.remove("active");
        section.querySelector(".productTabsContent.active").classList.remove("active");

        // add active class to new tabs
        button.classList.add("active");
        matchingTab.classList.add("active");
    });

    /**************
     Product Availability
     ***************/
    fetch(`${window.Shopify.routes.root}variants/${new URLSearchParams(window.location.search).get("variant")}/?section_id=section-product-pickup-availability`)
        .then(response => response.text())
        .then(text => {
            const container = document.querySelector('.productPickupAvailabilityContainer');
            const pickupAvailabilityHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');

            container.appendChild(pickupAvailabilityHTML);
        })
        .catch(e => {
            console.error(e);
        });


    /**************
     Product ATC
     ***************/
    section.querySelector('.productATC')?.addEventListener("click", async function () {

        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (section.querySelector('.productSellingLabelInput.sub')?.checked) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productSellingLabelBodyBottomWrapContentSelect')?.value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });

    /**************
     Product Back In Stock
     ***************/
    section.querySelector(".productEmailBackInStockForm")?.addEventListener("submit", async function (e) {
        e.preventDefault();

        // add loading
        e.submitter.classList.add("loading");

        // send request to Klaviyo to notify when back in stock
        await sendKlaviyoBackInStockRequest(this.querySelector(".productEmailBackInStockFormInput").value, parseInt(new URLSearchParams(window.location.search).get("variant")));

        // remove loading
        e.submitter.classList.remove("loading");

        // hide form
        this.classList.remove("active");

        // show success
        section.querySelector(".productEmailBackInStockSuccess").classList.add("active");
    });
});

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}